import React from 'react'

function NotFound() {
    return (
        <div className="not_found_container">
            <div>Sorry</div>
            <div>
                The page you're looking for is not found.
            </div>
        </div>
    )
}

export default NotFound
